import { Sheet } from '@zoomit/mobile-sheet';
import { Box, Modal } from '@zoomit/primitives';
import { isMobile } from '@zoomit/web-kit';
import { Button, cssVar, ModalActions, ModalHead, theme, Typography } from '@zoomit/zoomit-ds';

import type { AttractionContactInfo } from '../../../types/attraction';

export type Props = {
  data: AttractionContactInfo[];
  isOpen: boolean;
  onClose: () => void;
};

export function AttractionContactInfoPopover(props: Props) {
  if (!props.isOpen && !isMobile) return <></>;
  return isMobile ? <ContactInfoBottomSheet {...props} /> : <ContactInfoModal {...props} />;
}

function ContactInfoBottomSheet(props: Props) {
  const { data, onClose, isOpen } = props;

  return (
    <Sheet isOpen={isOpen} onClose={onClose} className="text-text">
      <Sheet.Container>
        <Sheet.Header showDragHandle>
          <div className="px-6 pb-4">
            <Typography
              tag="h3"
              variant={'h5'}
              lineHeight={1.75}
              fontWeight="bold"
              className="border-r-primary1 border-r-4 border-solid pr-3"
            >
              اطلاعات تماس
            </Typography>
          </div>
        </Sheet.Header>
        <Sheet.Content>
          <ul className="text-body px-6 pb-4">
            {data.map(({ title, value, href, icon }) => (
              <li
                key={value}
                className="border-grey6 flex items-center gap-3 border-b border-solid p-4 last:border-0"
              >
                {icon}
                <div className="grow">{title}</div>
                <a
                  href={href}
                  className="hover:text-primary1 cursor-pointer overflow-hidden text-left text-nowrap text-ellipsis"
                  dir="ltr"
                >
                  {value}
                </a>
              </li>
            ))}
          </ul>
        </Sheet.Content>
        <Box className="bg-background1 px-6 py-3">
          <Button variant="outline" size="full width" onClick={onClose}>
            بستن
          </Button>
        </Box>
      </Sheet.Container>
      <Sheet.Backdrop />
    </Sheet>
  );
}

function ContactInfoModal(props: Props) {
  const { data, isOpen, onClose } = props;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalHead title={'اطلاعات تماس'} onClose={onClose} />
      <Box
        spacing={{ pt: 'x6', pb: 'x2', px: 'x4' }}
        backgroundColor={cssVar(theme.background2)}
        className="text-text text-body space-y-2"
      >
        {data.map(({ title, value, href, icon }) => (
          <li key={value} className="border-grey6 flex items-center gap-3 border-b p-3 pb-4 last:border-0">
            {icon}
            <div className="grow">{title}</div>
            <a
              href={href}
              className="hover:text-primary1 cursor-pointer overflow-hidden text-left text-nowrap text-ellipsis"
              dir="ltr"
            >
              {value}
            </a>
          </li>
        ))}
      </Box>
      <ModalActions>
        <Button variant="outline" size="full width" className="!bg-background2" onClick={onClose}>
          بستن
        </Button>
      </ModalActions>
    </Modal>
  );
}
